// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { ConnectedApplicationInfo } from '@innolab-trader/tradovate-types'

export interface GetConnectedApplications {

}

export interface ConnectedApplications {
  connectedApplications: Array<ConnectedApplicationInfo>
  deviceLimit: number
  canHaveSecondMarketDataSubscription: boolean
  hasSecondMarketDataSubscription: boolean
}

/**
 * Validate GetConnectedApplications request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param _request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateGetConnectedApplications(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateGetConnectedApplications(_request: GetConnectedApplications): ValidationError[] {
  const errors: ValidationError[] = []



  return errors
}

export const getConnectedApplications = postEndpoint<GetConnectedApplications, ConnectedApplications>('/user/getConnectedApplications')
